import { getAddress } from '@/externals/postalCodeApi'

export const getAddressFromPostalCode = async (postalCode: string) => {
  const { data: addresses } = await getAddress(postalCode)
  const [{ ja }] = addresses
  return ja
}
